// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    deepOrange
} from '@mui/material/colors';
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import {DataGridPro,GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";

// App Imports
import {
    getCalcHierarchyAddOn,
    getCalcHierarchyBase
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changePayment} from "./paymentSlice";
import {changeRowSelect} from "../../Menus/rowSelectSlice";
import {changeObligationHierarchy} from "../WorkIssuanceObligation/obligationHierarchySlice";
import {WorkIssuancePaymentGridColumns} from "./WorkIssuancePaymentGridColumns";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {getContractHeaderStandard} from "../../Contract/ContractClient";
import LinearIndeterminate from "../../CommonComponents/Progress";


// main function
export default function WorkIssuancePaymentGrid(props) {

    // ****************** BEGIN STATES ****************************

    const [selectorMaxId, setSelectorMaxId] = React.useState(0);
    const [retrievedRows, setRetrievedRows] = useState([0]);
    const [progressSpinner, setProgressSpinner] = React.useState(false);
    const [contracts, setContracts] = useState([]);
    const [contractHeader, setContractHeader] = React.useState([]);
    const [selectorContractName, setSelectorContractName] = React.useState([]);
    const [selectorContractHeader, setSelectorContractHeader] = React.useState([]);
    const [submitting, setSubmitting] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpId = useSelector((state) => state.obligationHierarchySlc.value.addOnCdpId);
    const selectorHierarchyLevel = useSelector((state) => state.obligationHierarchySlc.value.addOnHierarchyLevel);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.workSlc.value.propertyId);
    const cashState = useSelector((state) => state.workIssuanceSlc.value.cashState);
    const accrualState = useSelector((state) => state.workIssuanceSlc.value.accrualState);
    const liabilityState = useSelector((state) => state.workIssuanceSlc.value.liabilityState);
    const ultimatesState = useSelector((state) => state.workIssuanceSlc.value.ultimatesState);
    const fetchProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const fetchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.fetchVersionNumber);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************

    const fetchcontractHeaders = () => {
        if (selectorContractId > 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};


    const fetchPayment = () => {
        if (fetchProductId > 0
        ){
            console.log("Payment base fetch triggered.")
            console.log("fetchProductId = ", fetchProductId);
            console.log("cashState = ", cashState);
            console.log("accrualState = ", accrualState);
            console.log("liabilityState = ", liabilityState);
            console.log("ultimatesState = ", ultimatesState);
            setSubmitting(true);
            let calcType = null;
            if (cashState === true) {
                calcType = "Payment Amount";
            } else if (accrualState === true) {
                calcType = "Accrual Payment Amount";
            } else if (liabilityState === true) {
                calcType = "Liability Payment Amount";}
            else if (ultimatesState === true) {
                calcType = "Ultimate Payment Amount";
            }
            getCalcHierarchyBase(fetchProductId,fetchVersionNumber, calcType)

                .then(data => {
                    console.log(data);
                    setContracts(data);
                    // Find IDs where hierarchy is a substring of another record's hierarchy
                    const ids = data
                        .filter(item =>
                            data.some(
                                other =>
                                    other.id !== item.id &&
                                    other.hierarchy.includes(item.hierarchy)
                            )
                        )
                        .map(item => item.id);
                    setRetrievedRows(ids);
                    setSubmitting(false);
                    console.log("retrieved row ids:", ids);
                    console.log("length of obligation data:", data.length);
                    const maxId = Math.max(...data.map(item => item.id));
                    setSelectorMaxId(maxId);
                    console.log("max id of obligation data:", maxId);
                })}};


    const fetchMorePayments = (rowData) => {
        if (rowData.id && !retrievedRows.includes(rowData.id)) {
            setProgressSpinner(true);
            setRetrievedRows((retrievedRows) => [...retrievedRows, rowData.id]);
            console.log("fetching more obligations");
            console.log("selectorCdpId: ", selectorCdpId);
            console.log("selectorHierarchy: ", selectorHierarchyLevel);
            console.log("selectorHierarchyLevel: ", selectorHierarchyLevel);
            console.log("selectorMaxId: ", selectorMaxId);
            getCalcHierarchyAddOn(rowData.cdpId, rowData.hierarchy, rowData.hierarchyLevel, selectorMaxId, "Obligation")

                .then(data => {
                    console.log(data);
                    const ids = data.map(row => row.id);
                    setRetrievedRows((retrievedRows) => [...retrievedRows, ...ids]);
                    console.log("row ids");
                    console.log(ids);
                    setContracts((contracts) => [...contracts, ...data]);
                    console.log("length of obligation data:", data.length);
                    const maxId = Math.max(...data.map(item => item.id));
                    setSelectorMaxId(maxId);
                    console.log("max id of obligation data:", maxId);
                    setProgressSpinner(false);
                })}};

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchcontractHeaders()
    }, []);


    useEffect(() => {
        console.log("Loading the contract grid...");
        fetchPayment();
    }, []);


    useEffect(() => {
        console.log("Use Effect: payment fetch triggered by grid refresh = true");
        console.log("selectorProductId = ", selectorProductId);
        fetchPayment();
        dispatchData(changeWorkIssuance({paymentGridRefresh: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.paymentGridRefresh)===true]);


    useEffect(() => {
        setContracts([]);
        dispatchData(changeWorkIssuance({clearData: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.clearData)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClickedRow = (rowData) => {
        console.log("clickedRow", rowData);
        console.log("clicked id", rowData.id);
        console.log("clicked cdp_id", rowData.cdpId);
        console.log("clicked cdpv_id", rowData.cdpvId);
        console.log("clicked hierarchy", rowData.hierarchy);
        console.log("clicked hierarchy level", rowData.hierarchyLevel);
        dispatchData(changeObligationHierarchy({
            addOnCdpId: rowData.cdpId,
            addOnHierarchy: rowData.hierarchy,
            addOnHierarchyLevel: rowData.hierarchyLevel}));
        fetchMorePayments(rowData);
    }

    function handleMousedRow(data) {
        console.log('moused row');
        console.log(data);
        dispatchData(changeRowSelect({contractId: data.contractId, contractSectionId: data.contractSectionId,
            cdpId: data.cdpId, cdpvId: data.cdpvId, cdpvfId: null, csfId: null}));
        console.log("cdp id");
    }

    // *************** END CONTROLS *******************************


    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
        )}

    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={contracts.id} />,
        [],
    );

    const getTreeDataPath = (contracts) => contracts.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
        width: 330,
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
        {submitting && <LinearIndeterminate/>}

        <Box sx={{ height:800 , width: '100%',

            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
        }}
        >
            <div>

            </div>


            {progressSpinner &&
                (
                    <Box
                        position="absolute"
                        top={0}
                        left={0}
                        width="100%"
                        height="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="rgba(255,255,255,0.5)" // optional dimmed overlay
                        zIndex={10}
                    >
                        <CircularProgress />
                    </Box>
                )}
            <DataGridPro
                experimentalFeatures={{ newEditingApi: true }}
                // sx={{backgroundColor: "rgb(30,144,255)"}}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                    // '& .level--1': { backgroundColor: "rgb(30,144,255)" },
                    // ... // your other styles
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'hierarchyOrder', sort: 'asc' }],
                    }
                    // filter: {
                    //     items: [
                    //         {
                    //             columnField: 'id',
                    //             operatorValue: '==',
                    //             value: '30'
                    //         }]
                    // }
                }}
                treeData
                aria-label={"Contracts"}
                // components={{ Toolbar: GridToolbar }}
                rows={contracts}
                // data={contracts}
                // getRowClassName={(contracts) => `level--${contracts.row.hierarchy.match(/p/g).length+1}`}
                getRowClassName={(contracts) => `level--${contracts.row.hierarchyLevel}`}
                // getDetailPanelHeight={getDetailPanelHeight}
                // onRowClick = {(contracts)=>handleClickedRow(contracts.row)}
                getDetailPanelContent={({ row }) => (
                    <Box sx={{
                        p: 2, flexGrow: 1,
                        bgcolor: deepOrange[100]
                        // backgroundColor: "rgb(255,204,153)"
                    }}>
                        <Box sx={{ml: 2}}>
                            <strong>Expression:</strong> {row.expression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Translation:</strong> {row.expressionTranslation}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Description:</strong> {row.expressionDescription}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Raw Expression:</strong> {row.rawExpression}
                        </Box>
                    </Box>
                )}
                // getDetailPanelHeight={({ row }) => {
                //     const lineHeight = 24;
                //     const padding = 32;
                //     const brSpacing = 32; // for 2 <br/><br/> lines
                //     const lines = [
                //         row.mockExpression,
                //         row.mockExpressionTranslation,
                //         row.rawExpression,
                //     ].filter(Boolean).length;
                //
                //     return padding + lines * lineHeight + brSpacing;
                // }}
                getDetailPanelHeight={getDetailPanelHeight}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={WorkIssuancePaymentGridColumns({
                    hideActions,
                    handleMousedRow,
                    handleClickedRow
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contract => contract.id}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                components={{
                    // Toolbar: CustomToolbar,
                    // Footer: CustomFooter,
                }}
            />
        </Box>
        </div>
    );

    // ****************** END RETURN ****************************


}



